import pitch from './logos/pitch.png';
import post from './logos/post.png';
import iiwk from './logos/iiwk.png';
import hessnatur from './logos/hessnatur.png';
import fashionnet from './logos/fashionnet.png';
import fashionnetwork from './logos/fashionnetwork.png';
import world from './logos/world.png';
import handelsblatt from './logos/handelsblatt.png';
import deutscher from './logos/deutscher.png';
import shuhkurier from './logos/schuhkurier.png';
import ecodesign from './logos/ecodesign.png';
import prosieben from './logos/prosieben.png';
import kultur  from './logos/kultur-kreativpiloten.png'
import newKultur from './logos/new-kultur-logo.png';

export const awardsItems = [
    {
      id: 0,
      logo: prosieben,
      link: 'https://www.joyn.de/serien/green-seven#folge',
      size: 200
    },
    {
      id: 1,
      logo: deutscher,
      link: 'https://unternehmen.nachhaltigkeitspreis.de/textileinzelhandel/jurybegruendung',
      size: 80
    },
    {
      id: 2,
      logo: handelsblatt,
      link: 'https://www.handelsblatt.com/unternehmen/dienstleister/nachhaltigkeit-das-amazon-fuer-kaputte-jeans/100067964.html&sa=D&source=docs&ust=1730733291652753&usg=AOvVaw1ik7u7SpNAxblR5QalFcWm',
      size: 180
    },
    {
      id: 3,
      logo: ecodesign,
      link: 'https://bundespreis-ecodesign.de/en/winners/2023-repair-rebels',
      size: 220
    },
    {
      id: 4,
      logo: post,
      link: 'https://rp-online.de/nrw/staedte/duesseldorf/start-up-in-duesseldorf-reparieren-statt-wegwerfen_aid-85565341',
      size: 180
    },
    {
      id: 5,
      logo: newKultur,
      link: 'https://kultur-kreativpiloten.de/titeltraeger-in/repair-rebels/',
      size: 200
    },
    {
      id: 6,
      logo: shuhkurier,
      link: 'https://www.schuhkurier.de/repair-rebels/',
      size: 200
    },
    {
      id: 7,
      logo: pitch,
      link: 'https://www.linkedin.com/feed/update/urn:li:activity:7066512831378022402?utm_source=share&utm_medium=member_desktop',
      size: 150
    },
    {
      id: 8,
      logo: handelsblatt,
      link: 'https://app.handelsblatt.com/technik/forschung-innovation/initiative-vision-lab-von-ki-bis-kleiderreparatur-diese-start-ups-zeigen-das-tech-potenzial-von-migranten/29075332.html',
      size: 180
    },
    {
      id: 9,
      logo: iiwk,
      link: 'https://www.hwk-duesseldorf.de/artikel/werkstatt-2023-31,0,5755.html#9',
      size: 210
    },
    {
      id: 10,
      logo: fashionnet,
      link: 'https://www.fashion-net-duesseldorf.de/de/news-43,37164.htm',
      size: 140
    },
    {
      id: 11,
      logo: world,
      link: 'https://www.worldfootwear.com/news/repair-rebels-making-repairing-the-new-normal-for-every-fashion-consumer/8712.html',
      size: 180
    },
    {
      id: 12,
      logo: fashionnetwork,
      link: 'https://de.fashionnetwork.com/news/Hessnatur-verkundet-funf-finalisten-fur-den-innovations-for-tomorrow-award,1407366.html',
      size: 180
    },
  ];
